import React, { createContext, useState, useEffect, useContext } from "react";

const API_URL = "https://api.rangpursadhima.cloud/api";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(null);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore login state on refresh
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedRole = localStorage.getItem("role");
    const storedUser = localStorage.getItem("user");

    if (storedToken && storedRole) {
      setToken(storedToken);
      setIsLoggedIn(true);
      setRole(storedRole);
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    }
    setLoading(false);
  }, []);

  // LOGIN → calls backend with email OR mobile
  const login = async (email, mobile, password) => {
    try {
      const res = await fetch(`${API_URL}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, mobile, password }),
      });

      if (!res.ok) {
        const error = await res.json();
        return { success: false, error: error.error || "Login failed" };
      }

      const data = await res.json();

      setIsLoggedIn(true);
      setRole(data.role || "USER");
      setUser(data.user || null);
      setToken(data.token || null);

      localStorage.setItem("token", data.token || "");
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("role", data.role || "USER");
      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      return { success: true, role: data.role };
    } catch (err) {
      console.error("Login error:", err);
      return { success: false, error: "Network error" };
    }
  };

  // LOGOUT
  const logout = () => {
    setIsLoggedIn(false);
    setRole(null);
    setUser(null);
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
  };

  // Get auth headers for API calls
  const getAuthHeaders = () => {
    return {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    };
  };

  // Check if user has specific permission
  const hasPermission = (permission) => {
    const ROLE_PERMISSIONS = {
      SUPERADMIN: ['dashboard', 'users', 'users-add', 'users-edit', 'users-delete', 'mark-attendance', 'mudat', 'profile', 'control-panel'],
      ADMIN: ['dashboard', 'users', 'users-add', 'users-edit', 'mark-attendance', 'mudat', 'profile'],
      EDITOR: ['dashboard', 'users', 'users-add', 'users-edit', 'mark-attendance', 'profile'],
      USER: ['profile'],
    };
    
    if (!role || !ROLE_PERMISSIONS[role]) return false;
    return ROLE_PERMISSIONS[role].includes(permission);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        role,
        user,
        token,
        loading,
        login,
        logout,
        getAuthHeaders,
        hasPermission,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider };
export const useAuth = () => useContext(AuthContext);
